import { h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { toCanvas } from "qrcode";
import { getQRCodeEventUrl, setQRCodeData } from "../api";
import { useEventSource } from "../hooks";
import { Chip } from "./Chip";

const qrId = Math.floor(Math.random() * 100000);

export function ScanPackQR(props: {
    onRead: (data: string) => unknown,
    onError?: (error: Event, recconect: (maxReconnections: number) => void) => void,
    connectionCondition?: boolean,
}) {
    const [idMode, setIdMode] = useState(false);
    const [status, setStatus] = useState("");
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    useEffect(() => {
        setQRCodeData(null, "");
        setQRCodeData(qrId, "");
        toCanvas(canvasRef.current, "https://production.internal.egzotech.com/qr.php?id=" + qrId, { scale: 3, margin: 2 });
    }, [true]);

    useEffect(() => {
        setIdMode(false);
    }, [status]);

    useEffect(() => {
        let textScan = "";
        let altCode = "";
        let isScanning = false;

        const callback = (e: KeyboardEvent) => {
            if (!isScanning) {
                textScan = "";

                if (e.key === "2" && e.altKey) {
                    e.preventDefault();
                    e.stopPropagation();
                    isScanning = true;
                }
            }
            else {
                e.preventDefault();
                e.stopPropagation();

                if (e.key.length > 1 && e.key !== "Shift" && e.key !== "Ctlr" && e.key !== "NumLock") {
                    isScanning = false;
                    props.onRead(JSON.stringify(textScan));
                }
                else {
                    if (e.altKey) {
                        altCode += e.key;
                    }
                    else if (altCode) {
                        altCode = "";
                        textScan += String.fromCharCode(29);
                    }
                    else if (e.key.length === 1) {
                        textScan += e.key;
                    }
                }
            }
        }

        window.addEventListener("keydown", callback);

        return () => {
            window.removeEventListener("keydown", callback);
        }
    })

    useEventSource(getQRCodeEventUrl(qrId), props.connectionCondition ?? true, {
        onOpen: () => {
            setStatus("")
        },
        onMessage: (data) => {
            props.onRead(data);
        },
        onError: (error, reconnect) => {
            if (!props.onError) {
                reconnect(5);
            }
            else {
                props.onError(error, reconnect);
            }
        },
        onFatal: () => {
            setStatus("no-connection");
        }
    }, [props.onRead, props.onError]);

    return <div class="scan-pack-qr">
        <Chip clickable type={status ? "error" : "secondary"} onClick={() => !status ? setIdMode(!idMode) : setIdMode(false)}
            tooltip="Naciśnij aby pokazać identyfikator" icon="qr_code">
            {status ? "Brak połączenia z Scan&Pack" : "Możesz użyć skanera Scan&Pack" }
        </Chip>
        <div class="id-qr" style={{ display: idMode ? "block" : "none" }}>
            <div style="display: flex; align-items: center">
                <div>Identyfikator: {qrId}</div>
                <canvas style="margin-left: 10px" ref={canvasRef} width={100} height={100}/>
            </div>
        </div>
    </div>;
}
